<h2 mat-dialog-title i18n="@@AddCharger">Add Charger</h2>

<mat-dialog-content style="padding-top: 12px;">
	<form [formGroup]="form" class="dialog-form">
		<mat-form-field appearance="outline" class="full-width">
			<mat-label i18n="@@PNumber">P-Number</mat-label>
			<input matInput formControlName="serialNumber" [maxlength]="serialNumberLength" />
			<span matTextSuffix class="char-count">{{ form.controls.serialNumber.value.length }}/{{ serialNumberLength }}</span>

			@if (form.controls.serialNumber.touched && form.controls.serialNumber.hasError('required')) {
				<mat-error i18n="@@PNumberIsRequired">P-Number is required</mat-error>
			} 
			@else if (form.controls.serialNumber.touched && (form.controls.serialNumber.hasError('minlength') || form.controls.serialNumber.hasError('maxlength'))) {
				<mat-error i18n="@@PNumberMustBeLength">P-Number must be {{ serialNumberLength }} characters long</mat-error>
			}
			@else if (form.controls.serialNumber.touched && form.controls.serialNumber.hasError('pattern')) {
				<mat-error i18n="@@PNumberMustStartWithPFollowedDigits">P-Number must start with 'P' followed by {{ serialNumberLength - 1 }} digits</mat-error>
			}
		</mat-form-field>

		<mat-form-field appearance="outline" class="full-width">
			<mat-label i18n="@@BluetoothPasskey">Bluetooth Passkey</mat-label>
			<input matInput formControlName="bluetoothPasskey" inputmode="numeric" maxlength="6" />
			<span matTextSuffix class="char-count">{{ form.controls.bluetoothPasskey.value.length }}/{{ bluetoothPasskeyLength }}</span>

			@if (form.controls.bluetoothPasskey.touched && form.controls.bluetoothPasskey.hasError('required')) {
				<mat-error i18n="@@BluetoothPasskeyIsRequired">Bluetooth Passkey is required</mat-error>
			}
			@else if (form.controls.bluetoothPasskey.touched && (form.controls.bluetoothPasskey.hasError('minlength') || form.controls.bluetoothPasskey.hasError('maxlength') || form.controls.bluetoothPasskey.hasError('pattern'))) {
				<mat-error i18n="@@BluetoothPasskeyMustBeLength">Bluetooth Passkey must be {{ bluetoothPasskeyLength }} digits long</mat-error>
			}
		</mat-form-field>
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="cancel()" i18n="@@Cancel">Cancel</button>
	<button matButton="elevated" color="primary" (click)="add()" [disabled]="form.invalid" i18n="@@Add">Add</button>
</mat-dialog-actions>
